import { useParams, Link } from "react-router-dom";
import { categories, machines } from "../data/machines";

export default function CategoryMachines() {
  const { id } = useParams();
  const category = categories.find(c => c.id === id);

  if (!category) return <p className="p-10">Category not found</p>;

  return (
    <div className="max-w-7xl mx-auto py-12 px-6">
      <h1 className="text-3xl font-bold mb-6">{category.title}</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {category.machineIds.map(mid => {
          const machine = machines[mid];
          return (
            <Link
              key={machine.id}
              to={`/machine/${machine.id}`}
              className="border rounded-xl shadow hover:shadow-xl overflow-hidden block"
            >
              <img src={machine.image} alt={machine.title} className="w-full h-48 object-cover" />
              <div className="p-5">
                <h2 className="text-lg font-bold">{machine.title}</h2>
                <p className="text-sm text-gray-600">{machine.desc}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
